import Vue from 'vue'
import Vuex from 'vuex'
import StoryApi from '@/api/StoryApi'
import KitApi from '@/api/KitApi'

Vue.use(Vuex)

export default new Vuex.Store(
  {
    state: {
      language: 'ENG',
      storyStep: 0,
      isMobile: window.outerWidth < 768,
      storyLoaded: false,
      storyData: {},
      kitLoaded: false,
      kitData: {}
    },
    mutations: {
      setLanguage (state, language) {
        state.language = language
      },
      setStoryStep (state, step) {
        state.storyStep = step
      },
      setMobile (state, isMobile) {
        state.isMobile = isMobile
      },
      async getStoryData (state, gapi){
        state.storyLoaded = false
        state.storyData = await StoryApi.getStoryData(gapi)
        state.storyLoaded = true
      },
      async getKitData (state, gapi){
        state.kitLoaded = false
        state.kitData = await KitApi.getKitData(gapi)
        state.kitLoaded = true
      }
    }
  }
)



// WEBPACK FOOTER //
// ./src/store/index.js